export type SafeNotificationLink = {
  allowed: boolean;
  external: boolean;
};

export const resolveSafeNotificationLink = (href?: string): SafeNotificationLink => {
  if (!href) return { allowed: false, external: false };
  const internal = href.startsWith('/') && !href.startsWith('//') && !href.includes('\\');
  const external = href.startsWith('https://');

  return { allowed: internal || external, external };
};
